class BGScroller extends HTMLElement {
  constructor() {
    super();   

    this.direction = this.getAttribute('data-direction');
    this.speed = parseFloat(this.getAttribute('data-speed'));
    this.scrollPos = 0;
    this.accelAmount = 0.4;
    this.delay = 0;
    
    window.addEventListener('scroll', this.onScrollHandler.bind(this));
    
    setInterval(() => {
      this.delay += (this.scrollPos - this.delay) * this.accelAmount;
      this.style.backgroundPositionX = this.delay+'px';

    }, 40);
  }

  onScrollHandler(){
    let scroll = window.scrollY;
    let windowHeight = window.innerHeight;
    

    var bodyRect = document.body.getBoundingClientRect(),
    elemRect = this.getBoundingClientRect(),
    offset   = elemRect.top - bodyRect.top;

    if((scroll + windowHeight) > offset && scroll < (offset + this.offsetHeight)){
      
      let perc = (scroll + windowHeight - offset) / (this.offsetHeight + windowHeight);
      this.scrollPos = perc*(this.offsetWidth*this.speed);
      
      if(this.direction.indexOf('left') >= 0){
        this.scrollPos *= -1;
      }
      
      
    }
  }
}
customElements.define('bg-scroller', BGScroller);